import { type PgEnum, pgEnum as drizzlePgEnum } from 'drizzle-orm/pg-core';

type Tuple<T extends string> = [T, ...T[]];

// drizzle's object overload types the column's enumValues as string[], and
// drizzle-zod then types the field as a bare string. Always hand it a tuple.
export function pgEnum<T extends Record<string, string>>(
  name: string,
  values: T,
): PgEnum<Tuple<T[keyof T]>>;
export function pgEnum<U extends string>(
  name: string,
  values: readonly [U, ...U[]],
): PgEnum<Tuple<U>>;
export function pgEnum(
  name: string,
  values: Record<string, string> | readonly string[],
) {
  const tuple = (
    Array.isArray(values) ? values : Object.values(values)
  ) as Tuple<string>;
  return drizzlePgEnum(name, tuple);
}
